import React from 'react';
import withData from 'util/hoc/with-data';
import HiringQuery from 'apps/hiring/util/query';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import 'apps/billing/styles/components/subcription-invite.scss';
import { jsonToInputParams } from 'library/util/graph';

class SubscriptionInviteModalContent extends React.Component {
  state = {
    q: '',
    active: {}
  }

  handleSelect = async (id) => {
    let active = {...this.state.active};
    active[id] = !resolve(active, `${id}`, false);

    this.setState({ active });
  }

  handleSearch = (e) => {
    this.setState({ q: e.target.value}, this.doSearch);
  }

  doSearch = () => {
    clearTimeout(this.searchtimeout);
    this.searchtimeout = setTimeout(this.search, 300);
  }


  search = async() => {
    if (this.state.loading) return;

    this.setState({
      loading: true,
      active: {}
    });

    const { q } = this.state;
    const { surveyed } = this.props;
    try {
      const params = {limit: 100, name: q};
      if(surveyed) params['has_surveyed'] = surveyed;

      const results = await HiringQuery(`
        {
        	organization {
            users (${jsonToInputParams(params)}) {
              pagination {
                limit,
                offset,
                total
              }
              results {
                id,
                name,
                email,
              }
            }
          }
        }
      `);
      this.props.graph_update(results.data);
    } catch (e) {
      console.error(e);
    }

    this.setState({
      loading: false
    });
  }

  mapEmployees = ({name, email, id}) => {
    if (resolve(this.props.graph_data, 'organization/users/pagination/total', []) === 0) return (<h2> No Results </h2>);
    const className = ['invite-employee-card', this.state.active[id] ? 'active': null].filter(lol=>lol).join(' ');
    return (
      <div onClick={() => this.handleSelect(id)} id={id} className={className}>
        <span> {name} </span>
        <span> {email} </span>
      </div>
    );
  }

  handleSumbit = () => {
    const { active } = this.state;
    const out  = [];

    if (!Object.keys(active).length) return;

    for (const id in active) {
      if (active[id]) {
        const user = resolve(this.props.graph_data, 'organization/users/results', []).find(c => c.id == id);
        out.push(user);
      }
    }

    this.props.handleSumbit(out, this.props.addType);
    this.props.onClose();
  }

  render () {
    const {
      q
    } = this.state;

    const {
      graph_loading,
      buttonText='Send',
      onClose,
      title='Invite Employee For Subscription',
      exclude=[],
      graph_data
    } = this.props;



    return (
      <div className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <h1> {title} </h1>
            <a onClick={onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body invite-employee-container">
          <label>
            Search
            <input value={q} onChange={this.handleSearch} />
          </label>
          <div className='invite-employee-results'>
            { graph_loading
              ? (<center><h1> Loading </h1></center>) :
              resolve(graph_data, 'organization/users/results', []).filter(c => !exclude.includes(c.id)).map(this.mapEmployees)
            }
          </div>
        </div>
        <div className='invite-employee-footer'>
          <button onClick={() => this.handleSumbit()} disabled={!this.state.active}> {buttonText} </button>
        </div>
      </div>
    );
  }
}

SubscriptionInviteModalContent.propTypes = {
  graph_loading: PropTypes.bool,
  graph_data: PropTypes.object,
  graph_update: PropTypes.func,
  onClose: PropTypes.func,
  buttonText: PropTypes.string,
  title: PropTypes.string,
  handleSumbit: PropTypes.func,
  addType: PropTypes.func,
  surveyed: PropTypes.func,
  exclude: PropTypes.array
};

SubscriptionInviteModalContent.query = async (token, props) =>
{
  const { surveyed } = props;
  const params = {limit: 100};
  if(surveyed) params['has_surveyed'] = surveyed;

  return HiringQuery(`
    {
    	organization {
        users (${jsonToInputParams(params)}) {
          pagination {
            limit,
            offset,
            total
          }
          results {
            id,
            name
            email,
          }
        }
      }
    }`);
};

export default withData(SubscriptionInviteModalContent);
